
export default class UserAgent {
  static get onIOS(): boolean {
    return /iphone|ipod|ipad/i.test(this.ua)
  }

  private static get ua() {
    return window.navigator.userAgent.toLowerCase()
  }
}
